import { BiPaiGame } from "./proto/bipai_game";



const { ccclass, property } = cc._decorator;

@ccclass
export default class NetMessageDataBiPaiGame {
    //发送命令名|发送结构体|收包命令|收包结构体|协议类型:1为登录服，2为麻将游戏服，3为Skynet扑克服
    //单播消息 游戏信息 登录重连时发送

    static GameInfo: any[] = [null, null, 'Game.GameInfo', BiPaiGame.GameInfo, 3]    
    static BankerNotify: any[] = [null, null, 'Game.BankerNotify', BiPaiGame.BankerNotify, 3]    
    static DealCardNotify: any[] = [null, null, 'Game.DealCardNotify', BiPaiGame.DealCardNotify, 3]    
    static MoreCard: any[] = ['Game.MoreCardReq', BiPaiGame.MoreCardReq, 'Game.MoreCardRsp', BiPaiGame.MoreCardRsp, 3]    
    static MoreCardNotify: any[] = [null, null, 'Game.MoreCardNotify', BiPaiGame.MoreCardNotify, 3]    
    static OpenCard: any[] = ['Game.OpenCardReq', BiPaiGame.OpenCardReq, 'Game.OpenCardRsp', BiPaiGame.OpenCardRsp, 3]    

    static Discard: any[] = ['Game.DiscardReq', BiPaiGame.DiscardReq, 'Game.DiscardRsp', BiPaiGame.DiscardRsp, 3]    
    static DiscardNotify: any[] = [null, null, 'Game.DiscardNotify', BiPaiGame.DiscardNotify, 3]    
    static Follow: any[] = ['Game.FollowReq', BiPaiGame.FollowReq, 'Game.FollowRsp', BiPaiGame.FollowRsp, 3]   
    static FollowNotify: any[] = [null, null, 'Game.FollowNotify', BiPaiGame.FollowNotify, 3]    
    static GameSettle: any[] = [null, null, 'Game.GameSettle', BiPaiGame.GameSettle, 3] 
    
    static SysOpen: any[] = ['Game.SysOpenReq', BiPaiGame.SysOpenReq, 'Game.SysOpenRsp', BiPaiGame.SysOpenRsp, 3]   

    static TimeoutNotify: any[] = [null, null, 'Game.TimeoutNotify', BiPaiGame.TimeoutNotify, 3]    
    static AckReq: any[] = ['Game.AckReq', BiPaiGame.AckReq, null, null, 3]   

    static CardReocrderNotify: any[] = [null, null, 'Game.CardReocrderNotify', BiPaiGame.CardReocrderNotify, 3] 

    static Assistant: any[] = [null, null, 'Game.Assistant', BiPaiGame.Assistant, 3] 

}

